<template>
    <fieldset :disabled="loading">
        <div v-if="data" class="roundbox">
            <div class="rbcontent head">
                <button v-if="hasAuth('Draft')" type="button" class="btn btn-outline-secondary mlxxs float-right" @click="$router.push({ name:'DraftDetail', params: { id: '000000000000000000000000' }, query: {incomingDocId:  data.Id} })" :title="translate('incomingDocument.createJobForThisDocumentText')">{{ translate('incomingDocument.createJobForThisDocument') }}</button>
                <h2 v-if="data.name">{{data.name}}</h2>
            </div>
            <div v-if="!loading" class="">
                <div class="row no-gutters">
                    <div class="col">
                        <div class="rbcontent">
                            <table class="table table-borderless table-sm ozet">
                                <tbody>
                                    <tr>
                                        <td style="width:150px;">{{translate('incomingDocFilter.documentNo')}}</td>
                                        <td style="width:1px;">:</td>
                                        <td style="font-weight:bold;">{{this.data.Id}}</td>
                                    </tr>
                                    <tr>
                                        <td style="width:150px;">{{translate('targetSystemImport.kind')}}</td>
                                        <td style="width:1px;">:</td>
                                        <td style="font-weight:bold;">{{this.data.type}}</td>
                                    </tr>
                                    <tr v-show="data.archiveType">
                                        <td>{{translate('incomingChannel.archiveKind')}}</td>
                                        <td>:</td>
                                        <td v-if="data.archiveType == 'Delete'">{{translate('incomingChannel.sil')}}</td>
                                        <td v-if="data.archiveType == 'FileSystem'">{{translate('incomingChannel.filePath')}}</td>
                                        <td v-if="data.archiveType == 'SFtp'">SFTP</td>
                                        <td v-if="data.archiveType == 'Ftp'">FTP</td>
                                    </tr>
                                    <tr v-if="data.Document">
                                        <td>{{translate('incomingDocument.doc')}}</td>
                                        <td>:</td>
                                        <td style="padding:0">
                                            <table class="table table-borderless table-hover table-sm">
                                                <tbody>
                                                    <tr>
                                                        <td style="padding:0" >
                                                            <file-download-link  :isActive="!data.isArchived" :isOnlineView="onlineViewEnabled" :document="data.Document" @download="downloadDocument" @preview="showFilePreviewDocument"></file-download-link>
                                                        </td>
                                                        <!-- <td>
                                                            <file-download-link  :isActive="!data.isArchived" :document="data.Document" @download="downloadDocument" @preview="showFilePreviewDocument"></file-download-link>
                                                        </td> -->
                                                        <td class="text-muted text-right" style="white-space:pre">
                                                            <div v-if="data.Document">
                                                            <span>{{data.Document.Size | prettyBytes}}</span>
                                                            </div>
                                                            <div v-else>
                                                            <span>{{translate('calculating')}}</span>
                                                            </div>
                                                         </td>                                                         
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('incomingDocument.archived')}}</td>
                                        <td>:</td>
                                        <td v-if="data.isArchived == true">{{translate('yes')}}</td>
                                        <td v-if="data.isArchived == false">{{translate('no')}}</td>
                                    </tr>
                                    <tr v-if="data.isArchived == true">
                                        <td>{{translate('incomingDocument.archiveTime')}}</td>
                                        <td>:</td>
                                        <td>{{data.archiveDate}}</td>
                                    </tr>
                                    <tr v-if="data.isArchived == false">
                                        <td>{{translate('incomingDocument.archiveDate')}}</td>
                                        <td>:</td>
                                        <td>{{this.calculatedArchiveDate}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{translate('incomingDocFilter.read')}}</td>
                                        <td>:</td>
                                        <td v-if="data.isRead == true">{{translate('yes')}}</td>
                                        <td v-if="data.isRead == false">{{translate('no')}}</td>
                                    </tr>
                                    <tr v-if="data.readDate != null">
                                        <td>{{translate('incomingDocument.readDate')}}</td>
                                        <td>:</td>
                                        <td>{{data.readDate | moment("DD.MM.YYYY  H:mm:ss")}}</td>
                                    </tr>
                                    <!-- v-if="data.Category || isAdmin" -->
                                    <tr >
                                        <td>{{translate('draftEyp.category')}}</td>
                                        <td>:</td>
                                        <td>
                                            <template v-if="editCategory">
                                                <select-multiple :autocomplete="true" v-model="data.categoryIds" :list="categories"></select-multiple>
                                                <button type="button" class="btn btn-sm btn-outline-success float-right" @click="categorySelectChanged">{{translate('update')}}</button>
                                                <!-- <select-input
                                                    :autocomplete="true"
                                                    placeholder="Ara..."
                                                    :items="categories"
                                                    :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                                                    @change="categorySelectChanged"
                                                    >
                                                        <span v-if="data.Category">
                                                            {{data.Category.Name}}
                                                        </span>
                                                        <span v-else>Kategori yok</span>
                                                        <template v-slot:item="{item}">
                                                            <div style="padding:2px 0;">
                                                                {{item.Name}}
                                                            </div>
                                                        </template>
                                                </select-input> -->
                                            </template>
                                            <template v-else>
                                                <span v-if="foundCategories.length != 0"><label class="badge" v-for="c in foundCategories" :key="c.Id" style="margin-right:4px; background-color:#E1E1E1;">{{c.Name}}</label></span>
                                                <i v-else class="text-muted" style="font-size: 0.9rem;">{{translate('incomingDocument.noCategory')}}&nbsp;</i>
                                                <!-- v-if="isAdmin" -->
                                                
                                                <a  href="javascript:void(0)" @click="editCategory = true;" :title="translate('incomingDocument.editCategory')">
                                                    <icon-pencil-square/>
                                                </a>
                                            </template>
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td>Filtreler</td>
                                        <td>:</td>
                                        
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                        <div class="rbcontent" style="background-color: #ffc1071f!important; border-top: 1px solid rgba(0, 0, 0, 0.03); border-bottom: 1px solid rgba(0, 0, 0, 0.03); margin-bottom: 50px;">
                            <div v-if="!loading">
                                <div v-if="this.responsibleUserCount > 1" style="font-weight:bold; padding: 5px;">{{translate('incomingDocument.responsibleUsers')}}</div>
                                <div v-if="this.responsibleUserCount == 1" style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.responsibleUser')}}</div>
                                <table v-if="this.responsibleUserCount != 0" class="table table-borderless table-hover">
                                    <tbody>
                                        <tr v-for="(t,counter) in this.recipients.Users" :key="counter" style="border-bottom:1px solid rgba(0,0,0,.04)">
                                            <td style="width:1px; vertical-align:middle; text-align:center; padding-left:12px; opacity:0.7" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="green" class="bi bi-arrow-right-circle-fill" viewBox="0 0 48 48"><path d="m21.05 32.45 13.5-13.5-1.75-1.7L21.05 29l-5.9-5.95-1.7 1.75ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z"/></svg>
                                            </td>
                                            <td>
                                                <div class="">
                                                    <div style="align-items: center">
                                                        
                                                        <span>
                                                            <img v-auth-image="t.ProfilePictureUrl" class="flow-picture" />
                                                            <b>{{t.FullName}}</b>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="float-right text-muted" style="margin-top: -20px; position: relative;"><small>{{t.Date | datetime}}</small></div>

                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else>
                                <div>{{translate('loading')}}</div>
                            </div>

                            <div v-if="!loading">
                                <div v-if="this.responsibleDepartmentCount > 1" style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.responsibleDepartments')}}</div>
                                <div v-if="this.responsibleDepartmentCount == 1" style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.responsibleDepartment')}}</div>
                                <table v-if="this.responsibleDepartmentCount != 0" class="table table-borderless table-hover">
                                    <tbody>
                                        <tr v-for="(c,counter) in this.recipients.Departments" :key="counter" style="border-bottom:1px solid rgba(0,0,0,.04)">
                                            <td style="width:1px; vertical-align:middle; text-align:center; padding-left:12px; opacity:0.7" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="green" class="bi bi-arrow-right-circle-fill" viewBox="0 0 48 48"><path d="m21.05 32.45 13.5-13.5-1.75-1.7L21.05 29l-5.9-5.95-1.7 1.75ZM24 43q-3.9 0-7.375-1.5t-6.05-4.075Q8 34.85 6.5 31.375 5 27.9 5 24q0-3.95 1.5-7.425Q8 13.1 10.575 10.55 13.15 8 16.625 6.5 20.1 5 24 5q3.95 0 7.425 1.5Q34.9 8 37.45 10.55 40 13.1 41.5 16.575 43 20.05 43 24q0 3.9-1.5 7.375t-4.05 6.05Q34.9 40 31.425 41.5 27.95 43 24 43Z"/></svg>
                                            </td>
                                            <td>
                                                <div class="">
                                                    <div  style="align-items: center">
                                                        <span v-if="c.Name">
                                                            <b>{{c.Name}}</b>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="float-right text-muted" style="margin-top: -20px; position: relative;"><small>{{c.Date | datetime}}</small></div>

                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                    
                    <!-- KEP AYRINTILARI BAŞLANGICI-->
                    <div v-if="data.kepDetails != null" class="col" style="background-color:rgba(0,0,0,.02); border-left: 1px solid rgba(0,0,0,.03);">
                        <div class="rbcontent" style="padding-left:15px;">
                            <div class="row" style="margin-left: 0px">
                                <div class="col" style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.kepDetails')}}</div>
                                <div class="col"><button class="btn btn-sm btn-primary float-right" @click="showRemDetail">{{translate('more')}}</button></div>
                            </div>
                            <table class="table table-borderless table-hover">
                                <tbody>
                                    <tr v-if="data.kepDetails.remMessageId != null">
                                        
                                        <td style="padding:0">
                                            <table class="table table-borderless table-sm">
                                                <tbody>
                                                    <tr v-show="data.kepDetails.Subject">
                                                        <td>{{translate('draftEyp.subject')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.kepDetails.Subject}}</td>
                                                    </tr>
                                                    <tr v-show="data.kepDetails.sentDate">
                                                        <td>{{translate('incomingDocument.sentTime')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.kepDetails.sentDate | moment("DD.MM.YYYY  H:mm:ss")}}</td>
                                                    </tr>
                                                    <tr v-if="data.kepDetails.Sender != null">
                                                        <td>{{translate('incomingDocument.senderName')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.kepDetails.Sender.Name}}</td>
                                                    </tr>
                                                    <tr v-if="data.kepDetails.Sender != null">
                                                        <td>{{translate('incomingDocument.senderAddress')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.kepDetails.Sender.Address}}</td>
                                                    </tr>
                                                    <tr v-if="data.kepDetails.Recipients != null">
                                                        <td>{{translate('incomingDocument.recipientName')}}</td>
                                                        <td>:</td>
                                                        <td> <div  v-for="r in data.kepDetails.Recipients" :key="r.Name"> {{r.Name}} </div></td>
                                                    </tr>
                                                    
                                                    <tr v-if="data.kepDetails.Recipients != null">
                                                        <td v-if="data.kepDetails.Recipients.length > 1">{{translate('incomingDocument.recipientAddresses')}}</td>
                                                        <td v-else>{{translate('incomingDocument.recipientAddress')}}</td>
                                                        <td>:</td>
                                                        <td> <div  v-for="e in data.kepDetails.Recipients" :key="e.Address"> {{e.Address}} </div></td>
                                                    </tr>
                                                    <tr>
                                                        <td>{{translate('draftEyp.attachments')}}</td>
                                                        <td>:</td>
                                                        
                                                        <td style="padding:0" >
                                                            <div v-if="!data.kepDetails.attachments || !data.kepDetails.attachments.length" class="text-muted" style="padding:4px; font-style:italic;">{{translate('incomingDocument.noAttachedFile')}}</div>
                                                            <table class="table table-borderless table-hover table-sm">
                                                                <tbody>
                                                                    <tr v-for="(d, counter) in data.kepDetails.attachments" v-bind:key="counter">
                                                                        <file-download-link  :isActive="!data.isArchived" :isOnlineView="onlineViewEnabled" :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                        
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="data.kepBody != null">
                                <div style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.kepBody')}}</div>
                                <p class="kepBodyText" v-html="getTruncatedText()"></p>
                            </div>
                        </div>
                    </div>
                    <!-- KEP AYRINTILARI BİTİŞ-->

                    <!-- UETS AYRINTILARI BAŞLANGICI-->
                    <div v-if="data.uetsDetails" class="col" style="background-color:rgba(0,0,0,.02); border-left: 1px solid rgba(0,0,0,.03);">
                        <div class="rbcontent" style="padding-left:15px;">
                            <div class="row" style="margin-left: 0px">
                                <div class="col" style="font-weight:bold; padding: 5px;" >{{translate('incomingDocument.uetsDetails')}}</div>
                                <div class="col"><button class="btn btn-sm btn-primary float-right" @click="showEypDetail">{{translate('more')}}</button></div>
                            </div>
                            <table class="table table-borderless table-hover">
                                <tbody>
                                    <tr>
                                        <td style="padding:0">
                                            <table class="table table-borderless table-sm">
                                                <tbody>
                                                    <tr v-show="data.uetsDetails.Subject">
                                                        <td>ID</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.uetsMessageId}}</td>
                                                    </tr>
                                                    <tr v-show="data.uetsDetails.Subject">
                                                        <td>{{translate('incomingDocument.reference')}} ID</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.referenceId}}</td>
                                                    </tr>
                                                    <tr v-show="data.uetsDetails.Subject">
                                                        <td>{{translate('draftEyp.subject')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.Subject}}</td>
                                                    </tr>
                                                    <tr v-show="data.uetsDetails.sentDate">
                                                        <td>{{translate('incomingDocument.sentTime')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.sentDate | moment("DD.MM.YYYY  H:mm:ss")}}</td>
                                                    </tr>
                                                    <tr v-if="data.uetsDetails.Sender != null">
                                                        <td>{{translate('incomingDocument.senderName')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.Sender.Name}}</td>
                                                    </tr>
                                                    <tr v-show="data.uetsDetails.Sender != null">
                                                        <td>{{translate('incomingDocument.senderAddress')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.Sender.Address}}</td>
                                                    </tr>
                                                    <tr v-if="data.uetsDetails.Recipient != null">
                                                        <td>{{translate('incomingDocument.recipientName')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.Recipient.Name}}</td>
                                                    </tr>
                                                    <tr v-show="data.uetsDetails.Recipient != null">
                                                        <td>{{translate('incomingDocument.recipientAddress')}}</td>
                                                        <td>:</td>
                                                        <td>{{data.uetsDetails.Recipient.Address}}</td>
                                                    </tr>
                                                    <!-- <tr>
                                                        <td>Ekler</td>
                                                        <td>:</td>
                                                        <td style="padding:0" >
                                                            <div v-if="!data.uetsDetails.attachments || !data.uetsDetails.attachments.length" class="text-muted" style="padding:4px; font-style:italic;">Ekli dosya yok.</div>
                                                            <table class="table table-borderless table-hover table-sm">
                                                                <tbody>
                                                                    <tr v-for="(d, counter) in data.uetsDetails.attachments" v-bind:key="counter">
                                                                        <file-download-link  :isActive="!data.isArchived" :document="d" @download="downloadAttachment" @preview="showFilePreview"></file-download-link>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr> -->
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <!-- UETS AYRINTILARI BİTİŞ-->
                    <file-preview v-if="fileDetail" :file="fileDetail" :isOnlineView="onlineViewEnabled" :viewer="viewerType" @close="fileDetail=null;"></file-preview>
                    <rem-preview v-if="remDetail" @close="remDetail=null;"></rem-preview>
                </div>
            </div>
            <div v-else>
                {{translate('loading')}}
            </div>
        </div>
    </fieldset>
</template>

<script>
import formMixin from '../formMixin.js';
import fileDownloadLink from '../components/FileDownloadLink.vue'
import filePreview from '../components/FilePreview.vue';
import RemPreview from '../components/RemPreview.vue';
import iconPencilSquare from '@/components/Icons/pencil-square.svg'
import selectMultiple from '../components/SelectMultiple.vue'


import axios from 'axios';
export default {
    mixins: [formMixin],
    components: {
        fileDownloadLink,
        filePreview,
        RemPreview,
        iconPencilSquare,
        selectMultiple
    },
    created() {
        this.loading = true;
        this.getOnlineViewPermission()
        .then(x => {
            this.onlineViewEnabled = x;
        }).catch(x => {
            console.warn("getOnlineViewPermission alınamadı:", x);
            this.onlineViewEnabled = true;
        });
        this.getData(this.$route.params.id).then(() => {
            if(this.data.Document != null){
                this.calculateArchiveDate();
            }else{
                this.calculatedArchiveDate = this.translate('errors.cantCalculate')
            }
            this.getUsers({
        predicate: "IsActive= true",
        }).then(x => {
            this.userList = x.Result;
            this.loadingLabel = this.emptyLabel;
            for(var i = 0; i< this.data.recipients.UserIds.length;i++){
                var u = this.data.recipients.UserIds[i]
                console.log(u)
                var user = this.userList.find(x => x.Id === u);
                if(user)
                this.recipients.Users.push(user );
            }
            if(this.recipients.Users.length == 1){
                this.responsibleUserCount = 1
            } else if(this.recipients.Users.length > 1){
                this.responsibleUserCount = 2;
            } else {
                this.responsibleUserCount = 0;
            }
            console.log(this.recipients.Users)
        });
        this.getCategories({predicate: "IsActive=true"})
            .then(x=> {
            this.categories = x.Result;
            this.loadingLabel = this.emptyLabel;
            for(var i = 0; i< this.data.categoryIds.length;i++){
                    var u = this.data.categoryIds[i]
                    console.log(u)
                    var category = this.categories.find(x => x.Id === u);
                    if(category)
                    this.foundCategories.push(category);
                }
        }).catch(x => {
                console.log("Kategori listesi yüklenemedi:", x);
            });
        this.getDepartments({ predicate: "IsActive= true" })
            .then(x => {
                this.departments = x.Result;
                this.loadingLabel = this.emptyLabel;
                for(var i = 0; i< this.data.recipients.DepartmentIds.length;i++){
                    var u = this.data.recipients.DepartmentIds[i]
                    var department = this.departments.find(x => x.Id === u);
                    if(department)
                    this.recipients.Departments.push(department);
                }
                if(this.recipients.Users.length == 1){
                this.responsibleDepartmentCount = 1
                } else if(this.recipients.Users.length > 1){
                    this.responsibleDepartmentCount = 2;
                } else {
                    this.responsibleDepartmentCount = 0;
                }
            }).catch(x => {
                console.log("Departman listesi yüklenemedi:", x);
            });

        })
        
        
        this.loading = false;
    },
    data() {
        return {
            modelName: 'incomingDoc',
            recipients: {
                Departments: [],
                Users:[]
            },
            data: {},
            editCategory: false,
            categories: [],
            foundCategories: [],
            departments: [],
            userList: [],
            fileDetail: null,       // Önizlemesi görüntülenecek dosya
            remDetail: false,
            loading: false,
            calculatedArchiveDate: null,
            responsibleUserCount: 0,
            responsibleDepartmentCount: 0,
            onlineViewEnabled: true,
            maxLength: 160,
        }
    },
    methods: {
        getTruncatedText() {
            // Remove HTML tags using a regular expression
            const plainText = this.data.kepBody.replace(/<[^>]+>/g, '');

            if (plainText.length <= this.maxLength) {
                return plainText;
            } else {
                return plainText.slice(0, this.maxLength - 3) + '...';
            }
        },
        showFilePreview(document, type) {
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "IncomingDoc"
        },
        showFilePreviewDocument(document, type) {
            
            this.fileDetail = {...document};
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "IncomingDoc"
            this.fileDetail.Id = null
            this.fileDetail.DocumentId = document.Id
        },
        showRemDetail(){
            this.remDetail = true
        },
        showEypDetail(){
            this.fileDetail = this.data.Document;
            this.viewerType = "eyp";
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.Id = null
            this.fileDetail.EntityType = "IncomingDoc"
        },
        downloadDocument(document, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/incomingDoc/createDocumentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: document.Id,
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        downloadAttachment(attachment, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/incomingDoc/createAttachmentUrl/`, {
                  EntityId : this.data.Id,
                  DocumentId: attachment.Id,
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        categorySelectChanged(){
                console.log(this.data)
                this.loading = true;
                axios.post("incomingDoc/UpdateCategories", {
                    EntityId : this.data.Id,
                    Categories : this.data.categoryIds
                }).then(x => {
                    this.data.categoryIds = x.data.categoryIds;
                    this.foundCategories = []
                    for(var i = 0; i< this.data.categoryIds.length;i++){
                        var u = this.data.categoryIds[i]
                        console.log(u)
                        var category = this.categories.find(x => x.Id === u);
                        if(category)
                        this.foundCategories.push(category);
                    }
                    this.loading = false;
                    this.editCategory = false;
                })
                .catch(x => {
                    window.processErrorResponse(x, this);
                    this.loading = false;
                })
        },
        copy(){
            this.$router.replace({ name: "DraftWithIncomingDoc", path: "000000000000000000000000",query: {incomingDocId:  this.data.Id} })
        },
        calculateArchiveDate(){
                this.data.Document.Date = new Date(this.data.Document.Date)
                if(this.data.isRead){
                this.calculatedArchiveDate = new Date(this.data.Document.Date.getTime() + (86400000 * this.data.readExpirationDay)).toLocaleDateString()
                }else{
                    this.calculatedArchiveDate = new Date(this.data.Document.Date.getTime() + (86400000 * this.data.expirationDay)).toLocaleDateString()
                }
        },
    }
}
</script>
<style scoped>
.divider-tablerow{
    background-color: lightgrey;
    height: 2px !important;
    width: 100%;
}
.flow-picture {
    width:1.4em;
    height:1.4em;
    vertical-align:middle;
    margin-right:4px;
    border-radius: 1.2em;
}
.kepBodyText{
    word-wrap: break-word; /* Prevents long words from overflowing */
    word-break: normal; /* Breaks words at any character, even within words */
    max-width: 100%; /* Ensures the text stays within the container */
    margin-left: 5px;
}
</style>